import { getTokens } from 'core/classes/helpers/StorageHelper'
import Logger from 'core/utils/Logger'
import settings from 'src/config/settings'

import { IPartnersCoverageGroup } from '../model/types'

import { IPartnersCoverageResponse } from './types'

/**
 * Partners coverage is built by a heavy procedure and does not change within a FY,
 * so the response is cached by `fYear` for the whole session.
 */
const fetchPartnersCoverageWithCache = () => {
  const cache = new Map<string, IPartnersCoverageGroup[]>()

  return async (
    fYear: number,
    signal?: AbortSignal,
    shouldResetCache: boolean = false
  ): Promise<IPartnersCoverageGroup[] | null> => {
    const cacheKey = `${fYear}`
    const cachedData = cache.get(cacheKey)

    if (cachedData && !shouldResetCache) {
      return cachedData
    }

    const url = `${settings.httpsServices.partner360}/api/v0/partnersCoverage/partnersCoverage`
    const [accessToken] = getTokens()

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          ...(accessToken ? { Authorization: accessToken } : {}),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ fYear }),
        signal,
      })

      if (!response.ok) {
        return null
      }

      const result: IPartnersCoverageResponse = await response.json()
      const data = result?.data ?? []

      cache.set(cacheKey, data)

      return data
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return null
      }

      Logger.error(`Fail to fetch partners coverage: FY${fYear}`)
      return null
    }
  }
}

export const fetchPartnersCoverage = fetchPartnersCoverageWithCache()
